export default __webpack_public_path__ + "static/media/Gotham-Bold.eaee1032.otf";